import React, { createContext, useContext, useReducer } from "react";
import { ACTION_TYPES, NewsReducer, NewsState } from "./news-reducer";
import { INewsPagedRespomse } from "models/response/news-paged-response";
import { PaginationResponse } from "models/pagination-response";

const NewsContext = createContext<NewsState | undefined>(undefined);
const NewsContextDispatchContext = createContext({} as any);

const NewsProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(NewsReducer, { news: {page:0, pageSize:8, items: [] as INewsPagedRespomse[] } as PaginationResponse<INewsPagedRespomse>, loading: false } as NewsState);

    return (
        <NewsContext.Provider value={state}>
            <NewsContextDispatchContext.Provider value={dispatch}>
                {children}
            </NewsContextDispatchContext.Provider>
        </NewsContext.Provider>
    );
}

const useNewsState = () => {
    const context = useContext(NewsContext);
    if (context === undefined) {
        throw new Error('useNewsState must be used within a NewsProvider');
    }
    return context;
}

const useNewsDispatch = () => {
    const context = useContext(NewsContextDispatchContext);
    if (context === undefined) {
        throw new Error('useNewsDispatch must be used within a NewsProvider');
    }
    return context;
}

export { NewsProvider, useNewsState, useNewsDispatch, ACTION_TYPES };